<template>

  <v-card>
  <v-toolbar class="elevation-1">
  <v-toolbar-title>  
    Middle Manager Teachers
    </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-text-field
          append-icon="search"
          label="Search"
          flat
          v-model="search"
          solo
        ></v-text-field>
    </v-toolbar>
    <v-data-table
              :headers="headers"
              :items="items"
              item-key="id"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
      <template slot="items" slot-scope="props">
           <td>{{ props.item.title }}</td>
          <td>{{ props.item.lastName }}</td>
          <td>{{ props.item.firstName }}</td>
          <td>{{ props.item.email }}</td>
          <td>
            <v-btn flat color="primary" slot="activator" ref="icon" small
                :to="{ name: 'TeacherEfforts', params: { teacherId: props.item.id, middleManagerId: middleManagerId }}"
            ><v-icon >assignment_turned_in</v-icon> Effort grades
            </v-btn>
            <v-tooltip bottom>
              <v-btn slot="activator" fab dark small color="primary" outline ref="icon"
                  :to="{ name: 'MyEffortsTeacher', params: { teacherId: props.item.id, teacher: props.item }}"
              ><v-icon dark>assignment</v-icon>
              </v-btn>
              <span>Grade Summary</span>
            </v-tooltip>
          </td>
      </template>
    </v-data-table>
  </v-card>

</template>


<script>
  import { getList, getListByPeriod, initialize, getManagerTeachersByPeriod } from '../utils/effort-tracking-api';
  import { globalStore } from '../main'
  
  export default {
    data: () => ({
        search: '',
        loading: false,
        totalItems: 0,
        rowsPerPageItems: globalStore.rowsPerPageItems ,
        pagination: { sortBy: 'lastName', rowsPerPage: globalStore.defaultRowsPerPage },
        headers: [
          { text: 'Title', value: 'title', sortable: false },
          { text: 'Last Name', value: 'lastName' },
          { text: 'First Name', value: 'firstName' },       
          { text: 'Email', value: 'email', sortable: false },
          { text: '', value: '', sortable: false }
        ],
        items: [],
        middleManagerId: 0
    }),
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        initialize().then(x => {
          this.loading = true;
          getManagerTeachersByPeriod(this.middleManagerId, this.pagination, this.search).then(data => {
            this.items = data.items;
            this.totalItems = data.count;
            this.loading = false;
          });
        });
      }
    },
    watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
          this.debouncedGetDataFromApi();
        },
        deep: true
      }
    },
    mounted () {
      var session = JSON.parse(localStorage.getItem('ef-session'));
      this.middleManagerId = Number(session.userdata.id);
      localStorage.setItem('middlemanagerid', session.userdata.id);
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
    },
  }
  
</script>



// WEBPACK FOOTER //
// src/components/MiddleManagerTeachers.vue